(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nodix-care-guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', (event) => {
    if (event.target.matches('.nodix-care__item')) event.target.open = true;
  });

  } catch(e) { console.error(e); }
})();
})();
